<template>
<div class="chapter">
<div class="inner_page">
<p class="half"><a id="ch00_fm01_half"></a><a id="page_i"></a>One Marriage under God</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch00_fm01_half.vue?6cd167ed